import React from 'react';
import useLatestSdk from '../../hooks/useLatestSdk';
import './LatestSdk.css';

const LatestSdk = () => {
  const {fullName, loading} = useLatestSdk();

  return (
    <span className='latestSdk'>{loading? 'Loading...' : fullName}</span>
  );
};

export default LatestSdk;
